import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.apply');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-apply',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/layout.apply/view.scss */
:host {
  display: block;
  min-height: 100vh;
}`],
})
export class LayoutApplyComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }
    public year: number = new Date().getFullYear();

    public async ngOnInit() {
        await this.service.init();
    }
}

export default LayoutApplyComponent;